import React, { FC, ReactElement } from 'react';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { clsx } from 'clsx';
// Resources
import { EventType } from '../../../core/apiTypes';
import { ImageEvent } from '../../../resources/images';
import { imageToCdn } from '../../../utils/images';

interface WickedImageProps {
    type: ImageEvent;
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => any;
}

const WickedImage: FC<WickedImageProps> = ({ type, className, style, onClick }): ReactElement => {
    const classes = useStyles();

    return (
        <img
            src={imageToCdn(EventType.WICKED, type)}
            alt={`${type}`}
            className={clsx(className, classes[type])}
            style={style}
            onClick={onClick}
        />
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        [ImageEvent.WickedMenu]: {
            width: 'calc(100% - 12px)',
            borderRadius: 4,
            '@media (max-width: 700px)': {
                width: 'calc(100% - 60px)',
                alignSelf: 'center',
            },
        },
        [ImageEvent.WickedDetails]: {
            width: 'calc(100%)',
            borderRadius: 4,
        },
        [ImageEvent.WickedModal]: {
            width: 'calc(100%)',
        },
        [ImageEvent.WickedBandeau]: {
            width: 300,
            height: 73,
            borderRadius: 8,
        },
    }),
);

export default WickedImage;
